/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Describes an additional service provided by shipping method. */
export interface Addon {
  /** External code, as defined in carrier's system. */
  code?: string;
  /** Additional data that has to be passed to use the addon. */
  data?: Record<string, string>;
  /** Description of the addon. */
  description?: string;
  /** Internal identifier of an addon. */
  name?: string;
}

/** Common address entity that used almost everywhere in Ingrid's API. */
export interface Address {
  /** List of address lines part of address such as street and building number */
  address_lines?: string[];
  /** Number of the apartment. */
  apartment_number?: string;
  /**
   * Attention field. Can be used to indicate an employee if the address is a
   * company address [optional]
   */
  attn?: string;
  /** in the UK some buildings do not have a number, only a name */
  building_name?: string;
  /** Care of part of address usually written as `c/o` [optional] */
  care_of?: string;
  /** Name of the city */
  city?: string;
  /**
   * Geolocation coordinates of the address. If reverse geolocation lookup of the
   * address was successful this property will be populated. If coordinates are
   * available they will be used to in service point search. In case of
   * `search_address` coordinates can also be set by merchant if known.
   */
  coordinates?: Coordinates;
  /**
   * Country should be specified as two uppercase letters (ISO Alpha-2).
   * Example `SE` for Sweden, `ES` for Spain.
   */
  country?: string;
  /** The door code to the main entrance of the building if applicable [optional] */
  door_code?: string;
  /** Floor number [optional] */
  floor_number?: string;
  /** Customer or company name */
  name?: string;
  /** ID of the PO Box [optional] */
  po_box_id?: string;
  /** Postal code (or zipcode in US) */
  postal_code?: string;
  /** Region can be a state or a province [optional] */
  region?: string;
  /** Name of the street. */
  street?: string;
  /** Number of the street. */
  street_number?: string;
  /**
   * Further division of regions. Example countries are GB, IE, IT, LT, MX
   * For example for The Republic Of Ireland there are 4 provinces (regions),
   * e.g. `Connacht` and 26 counties (subregions), e.g. `Galway`
   * Format is ISO 3166 where applicable, exceptions are e.g. Mexico [optional]
   */
  subregion?: string;
}

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

/** ConsolidatedShipmentDetails contains the details of a Consolidated Shipment that this shipment can be a part of. */
export interface ConsolidatedShipmentDetails {
  /** [Required] ID of the consolidated shipment that this shipment is part of. */
  consolidated_shipment_id?: string;
}

/**
 * Contents contains all goods sent in a Shipment or Parcel. Goods can either be
 * defined directly by providing the full details of the goods, it can be
 * referenced by transport order id or an external reference to goods defined by
 * an external system.
 */
export interface Contents {
  /** Description of the contents. [optional] */
  description?: string;
  /** External orders contained in this shipment. */
  external_orders?: ExternalOrderContentItem[];
  /** Goods a.k.a. line items. */
  goods?: LineItem[];
  /** Transport orders contained in this shipment, so called consolidated shipment. */
  transport_orders?: TransportOrderContentItem[];
}

/** @default "UNKNOWN" */
export type ContentsType =
  | "UNKNOWN"
  | "DOCUMENTS"
  | "GIFT"
  | "COMMERCIAL_SAMPLE"
  | "SALE"
  | "RETURN"
  | "OTHER"
  | "DANGEROUS_GOODS"
  | "HUMANITARIAN_DONATIONS";

/** Geolocation coordinates */
export interface Coordinates {
  /**
   * Latitude
   * @format double
   */
  lat?: number;
  /**
   * Longitude
   * @format double
   */
  lng?: number;
}

export interface CountShipmentsRequest {
  filtering?: Filtering;
}

export interface CountShipmentsResponse {
  counts?: ShipmentCount[];
}

/** Contains the necessary information about a customer in order to make a delivery */
export interface CustomerInfo {
  /** Customer's home address. */
  address?: Address;
  /** Customer's email. */
  email?: string;
  /** Customer's national identification number, eg. SSN. */
  national_identification_number?: string;
  /** Customer's mobile phone number. */
  phone?: string;
}

export interface Customs {
  /** Customs declaration provided in request. */
  declaration?: CustomsDeclaration;
  /** Customs declaration document available after booking the parcel with customs declaration request. */
  document?: CustomsDeclarationDocument;
}

export interface CustomsDeclaration {
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  cn22?: DeclarationCN;
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  cn23?: DeclarationCN;
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  cp72?: DeclarationCN;
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  electronic_invoice_fedex?: ElectronicInvoiceFedex;
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  electronic_invoice_lotte?: ElectronicInvoiceLotte;
  /**
   * Use GeneralCustomsDeclaration instead. [deprecated]
   * Deprecated, use GeneralCustomsDeclaration
   */
  electronic_invoice_ups?: ElectronicInvoiceUPS;
  general_customs_declaration?: GeneralCustomsDeclaration;
}

export interface CustomsDeclarationDocument {
  /** File format (ex. "pdf", "png"). */
  format?: string;
  type?: CustomsDeclarationDocumentType;
  /** The url where the declaration label is located. */
  url?: string;
}

/** @default "TYPE_UNKNOWN" */
export type CustomsDeclarationDocumentType =
  | "TYPE_UNKNOWN"
  | "TYPE_CN22"
  | "TYPE_CN23"
  | "TYPE_CP72"
  | "TYPE_ELECTRONIC_INVOICE_UPS"
  | "TYPE_ELECTRONIC_INVOICE_LOTTE"
  | "TYPE_ELECTRONIC_INVOICE_FEDEX"
  | "TYPE_ELECTRONIC_INVOICE";

/** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
export interface DateTimeRange {
  /** End of the interval. Date is returned in RFC3339 format. Example `2018-09-08T22:47:31Z`. */
  end?: string;
  /** Start of the interval. Date is returned in RFC3339 format. Example `2018-09-08T22:47:31Z` */
  start?: string;
}

export interface DeclarationCN {
  /** Contents explanation - short general description. */
  contents_explanation?: string;
  /** Content type of goods inside the parcel. For example - Sale, Gift etc. See ContentsType reference for details */
  contents_type?: ContentsType;
  /** Purchase currency. */
  currency?: string;
  /** EORI number for imports/exports from UK */
  eori_number?: string;
  /** List of items packed inside parcel. */
  items?: DeclarationCNItem[];
  /**
   * Total gross weight is parcel weight in grams (including packaging).
   * @format int64
   */
  total_gross_weight?: number;
}

export interface DeclarationCNItem {
  /** Country of origin - country were this item were produced. */
  country_of_origin?: string;
  /** General description of this item. */
  description?: string;
  /** Harmonized System tariff number. */
  hs_tariff_number?: string;
  /**
   * Quantity of this item.
   * @format int64
   */
  quantity?: number;
  /**
   * Total net weight of the item in grams (for the whole quantity).
   * @format int64
   */
  total_net_weight?: number;
  /**
   * Total value of this item (for the whole quantity).
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit)
   * For example, 25.99 USD should be converted to 2599
   * @format int64
   */
  total_value?: number;
}

/**
 * Delivery is the parcel with start and end destination. A delivery always
 * has one parcel that it belongs to.
 */
export interface Delivery {
  /** Addons available for the shipment. */
  addons?: Addon[];
  /** Origin address for this delivery. */
  address_from?: Address;
  /** The return address to which a delivery that is returned should be sent. */
  address_return?: Address;
  /** Destination address for this delivery. */
  address_to?: Address;
  /**
   * CarrierShipmentId is the internal identifier assigned by the carrier to the booked shipment or consignment.
   * Unlike the shipment_tracking_number, this value is used for system-to-system communication, support, or referencing
   * the shipment in carrier APIs. It is not visible to the end customer.
   */
  carrier_shipment_id?: string;
  /** Optional instructions to the courier. */
  courier_instructions?: string;
  /** Timestamp when delivery was created. */
  created_at?: string;
  /** State of the delivery. Possible values are 'created','booked','pickup'. */
  delivery_status?: string;
  /**
   * Time range when the deliveries will most likely be delivered to the customer. When time is set
   * to 00:00 it means Ingrid has presented a set of days or business days e.g. 2-3 Business days.
   */
  delivery_time?: DateTimeRange;
  /** Documents associated with the delivery. */
  documents?: Documents;
  /** Additional reference set by carrier which can be used to identify and search delivery. */
  external_ref?: string;
  /** Unique id of the delivery (uuid). */
  id?: string;
  /** Use documents.label_url instead. [deprecated] */
  label_url?: string;
  /** ID of the service point location if applicable. */
  location_ref?: string;
  /**
   * Indicates the kind of pickup location
   * - UNKNOWN_PICKUP_LOCATION_TYPE: Location type is not known for some reason
   *  - LOCKER: Locker location type. Example Instabox or a DHL locker
   *  - STORE: Can be a merchant's store or any other store that handles logistics
   *  - POSTOFFICE: Postal office
   *  - MANNED: A manned service point
   */
  location_type?: PickupLocationType;
  /** ID of the parcel which the delivery belongs to. */
  parcel_id?: string;
  /** Name of a Custom Shipping method used during booking. */
  requested_shipping_method?: string;
  /**
   * ReturnCode is a code that the end user is supposed to write on the physical package. Used instead of
   * a label or QR code, if available.
   */
  return_code?: string;
  /** Use documents.return_label_url instead. [deprecated] */
  return_label_url?: string;
  /** Shipping product ID for the return delivery. */
  return_shipping_method?: string;
  /** Tracking number for the return delivery. */
  return_tracking_number?: string;
  /** Tracking URL for return delivery if available */
  return_tracking_url?: string;
  /** Consolidated tracking number for all deliveries in a shipment. */
  shipment_tracking_number?: string;
  /** Shipping product ID for the delivery. */
  shipping_method?: string;
  /** Tracking number for the delivery. */
  tracking_number?: string;
  /** Tracking URL for the upcoming delivery if available. */
  tracking_url?: string;
  /** Transit time [deprecated]. */
  transit_time?: TransitTime;
  /** Timestamp when delivery was last updated. */
  updated_at?: string;
  /**
   * Weight of the delivery in grams.
   * @format uint64
   */
  weight?: number;
}

/** Length, height and width in millimeters. */
export interface Dimensions {
  /**
   * Height in millimeters. For example `50` is 0,05 m
   * @format uint64
   */
  height?: number;
  /**
   * Length in millimeters. For example `140` is 0,14 m
   * @format uint64
   */
  length?: number;
  /**
   * Width in millimeters. For example `20` is 2 cm
   * @format uint64
   */
  width?: number;
}

/**
 * Indicates intended direction of parcel, shipment etc.
 *
 *  - OUTBOUND: From merchant to customer.
 *  - RETURN: Return from customer to merchant.
 *  - UNSPECIFIED: Unspecified means we do not know the direction. It is the default state when we do not know any better.
 * @default "UNKNOWN_DIRECTION_TYPE"
 */
export type DirectionType = "UNKNOWN_DIRECTION_TYPE" | "OUTBOUND" | "RETURN" | "UNSPECIFIED";

export interface Documents {
  /** URL of the delivery's shipping label. */
  label_url?: string;
  /** QR code URL that can be used instead of the shipping label. */
  qr_code_url?: string;
  /** URL of the delivery's return label. */
  return_label_url?: string;
  /** QR code URL that can be used instead of the return shipping label. */
  return_qr_code_url?: string;
}

export interface ElectronicInvoiceFedex {
  /** Content type of goods inside the parcel. For example - Sale, Gift etc. See ContentsType reference for details */
  contents_type?: ContentsType;
  /** Purchase currency */
  currency?: string;
  /** Statement that provides the legal explanation that customs uses to process your shipment. Needs to meet certain country's law restrictions. */
  declaration_statement?: string;
  /** International Commercial Terms. */
  incoterms?: InCoTerms;
  /** List of items packed in the parcel */
  items?: ElectronicInvoiceFedexItem[];
}

export interface ElectronicInvoiceFedexItem {
  /** Country where this item was produced */
  country_of_origin?: string;
  /** General description of this item */
  description?: string;
  /** Harmonized System tariff number */
  hs_tariff_number?: string;
  /**
   * Quantity of this item
   * @format int64
   */
  quantity?: number;
  /** Quantity units of this item */
  quantity_units?: string;
  /**
   * Total net weight of this item in grams (for the whole quantity)
   * @format int64
   */
  total_net_weight?: number;
  /**
   * Total value of this item (for the whole quantity)
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit)
   * For example, 25.99 USD should be converted to 2599
   * @format int64
   */
  total_value?: number;
  /**
   * Value per unit of quantity
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit)
   * For example, 25.99 USD should be converted to 2599
   * @format int64
   */
  unit_value?: number;
}

export interface ElectronicInvoiceLotte {
  /** Buyer's personal customs clearance number/id. */
  buyer_personal_customs_clearance_number?: string;
  /** Purchase currency. */
  currency?: string;
  /** Date when the invoice was issued */
  invoice_date?: string;
  /** Unique number that identifies the invoice */
  invoice_number?: string;
  /** List of items packed inside parcel. */
  items?: ElectronicInvoiceLotteItem[];
  /** Seller's Customs Authorization Number. Required for orders above 6000 EUR. */
  seller_customs_authorization_number?: string;
  /** SoldTo is the address of the person who paid for the purchase. */
  sold_to?: Address;
}

export interface ElectronicInvoiceLotteItem {
  /** Brand of the item */
  brand?: string;
  /** Country of origin - country were this item were produced. */
  country_of_origin?: string;
  /** General description of this item. */
  description?: string;
  /** Harmonized System tariff number. */
  hs_tariff_number?: string;
  /**
   * Quantity of this item.
   * @format int64
   */
  quantity?: number;
  /**
   * Total value of this item (for the whole quantity).
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit)
   * For example, 25.99 USD should be converted to 2599
   * @format int64
   */
  total_value?: number;
}

export interface ElectronicInvoiceUPS {
  /** Contents explanation - short general description. */
  contents_explanation?: string;
  /** Content type of goods inside the parcel. For example - Sale, Gift etc. See ContentsType reference for details */
  contents_type?: ContentsType;
  /** Purchase currency. */
  currency?: string;
  /** Date when the invoice was issued */
  invoice_date?: string;
  /** Unique number that identifies the invoice */
  invoice_number?: string;
  /** List of items packed inside parcel. */
  items?: ElectronicInvoiceUPSItem[];
  /** SoldTo is the address of the person who paid for the purchase. */
  sold_to?: Address;
  /**
   * Total gross weight is parcel weight in grams (including packaging).
   * @format int64
   */
  total_gross_weight?: number;
}

export interface ElectronicInvoiceUPSItem {
  /** Country of origin - country were this item were produced. */
  country_of_origin?: string;
  /** General description of this item. */
  description?: string;
  /** Harmonized System tariff number. */
  hs_tariff_number?: string;
  /**
   * Quantity of this item.
   * @format int64
   */
  quantity?: number;
  /**
   * Total value of this item (for the whole quantity).
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit)
   * For example, 25.99 USD should be converted to 2599
   * @format int64
   */
  total_value?: number;
}

/** Reference to goods defined by an external system. */
export interface ExternalOrderContentItem {
  /** A reference to an external (merchant) order. */
  external_id?: string;
}

export interface FetchDeliveryStatusResponse {
  /**
   *  - CREATED: CREATED is the initial state of the delivery.
   *  - BOOKED: BOOKED indicates that delivery has been booked, also known as having a label generated for it.
   *  - PICKUP_REQUESTED: PICKUP_REQUESTED indicates that the shipment service marked the delivery as ready to be picked up.
   *  - PICKUP_SCHEDULED: PICKUP_SCHEDULED indicates that booking service recognized the aformentioned request and will include delivery
   * in the next pickup operation.
   *  - PICKUP_BOOKED: PICKUP_BOOKED indicates that the pickup operation that included this delivery has finished successfully.
   *  - IN_TRANSIT: IN_TRANSIT indicates that the delivery is under transportation.
   *  - DELIVERED: DELIVERED indicates that the package has been delivered by the carrier.
   *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
   *  - DELIVERY_IN_PROGRESS: DELIVERY_IN_PROGRESS indicates that the delivery is on its way.
   *  - ARRIVED_AT_PICKUP_POINT: ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready to be picked up by the client.
   *  - DELAYED: DELAYED indicates that the delivery will be delivered later than expected.
   *  - RETURNED: RETURNED indicates that the delivery has been returned.
   *  - INFO: INFO indicates some uncategorized event.
   *  - ERROR: ERROR indicates that some error occurred.
   *  - PICKUP_REGISTERED: PICKUP_REGISTERED indicates that the carrier has been informed about the delivery.
   *  - NOTIFICATION_SENT: NOTIFICATION_SENT indicates that a delivery notification has been sent to the customer.
   *  - BOOKING_RECEIVED_BY_CARRIER: BOOKING_RECEIVED_BY_CARRIER indicates that the carrier has received booking information for the parcel.
   *  - FAILED: FAILED indicates that there was an attempt to deliver the package but it failed.
   *  - FORWARDED_TO_THIRD_PARTY: FORWARDED_TO_THIRD_PARTY indicates that the package was handed over to another third party for continuation of delivery.
   *  - IN_CUSTOMS: IN_CUSTOMS indicates that the package is undergoing customs clearance.
   *  - REDIRECTED: REDIRECTED indicates that package has been redirected from its original path.
   *  - LOST: LOST indicates that package has been lost and delivery cannot proceed.
   *  - DAMAGED: DAMAGED indicates that package has been damaged.
   *  - RETURNED_TO_SENDER: RETURNED_TO_SENDER indicates that package will be returned to the sender.
   *  - PICKUP_DELAYED: PICKUP_DELAYED indicates that the package pickup from point of origin is delayed.
   *  - PICKED_UP: PICKED_UP indicates that the package was received from the point of origin.
   *  - UNDELIVERABLE: UNDELIVERABLE indicates that the package cannot be delivered.
   *  - CONTACT_MERCHANT_SUPPORT: CONTACT_MERCHANT_SUPPORT indicates that the consumer should contact merchant's customer support.
   *  - CONTACT_CARRIER_SUPPORT: CONTACT_CARRIER_SUPPORT indicates that the consumer should contact carrier's customer support.
   *  - INSTORE_ARRIVED_AT_PICKUP_POINT: `service-instore` specific statuses
   * INSTORE_ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
   *  - INSTORE_PARCEL_REFUSED: INSTORE_PARCEL_REFUSED indicates that the parcel has been refused by the customer.
   *  - INSTORE_PARCEL_PICKED_UP: INSTORE_PARCEL_PICKED_UP indicates that the parcel has been picked up by the customer.
   *  - INSTORE_PARCEL_OVERDUE: INSTORE_PARCEL_OVERDUE indicates that the parcel has not been picked up by the customer, and is overdue.
   *  - INSTORE_PARCEL_RETURNED: INSTORE_PARCEL_RETURNED indicates that the parcel has been returned by the customer.
   * It's indicates RETURN direction.
   *  - INSTORE_PARCEL_RELOCATED: INSTORE_PARCEL_RELOCATED indicates that the parcel has been relocated by store staff.
   *  - INVALID_BOOKING: INVALID_BOOKING indicates that a booking failed due to external reasons likely a carrier 400
   *  - CANCEL_FAILED: CANCEL_FAILED indicates that a shipment failed to cancel due to not allowed from carrier.
   */
  status?: Status;
}

export interface FetchShipmentMetadataResponse {
  order_number?: string;
  /**
   *  - CREATED: CREATED is the initial state of the delivery.
   *  - BOOKED: BOOKED indicates that delivery has been booked, also known as having a label generated for it.
   *  - PICKUP_REQUESTED: PICKUP_REQUESTED indicates that the shipment service marked the delivery as ready to be picked up.
   *  - PICKUP_SCHEDULED: PICKUP_SCHEDULED indicates that booking service recognized the aformentioned request and will include delivery
   * in the next pickup operation.
   *  - PICKUP_BOOKED: PICKUP_BOOKED indicates that the pickup operation that included this delivery has finished successfully.
   *  - IN_TRANSIT: IN_TRANSIT indicates that the delivery is under transportation.
   *  - DELIVERED: DELIVERED indicates that the package has been delivered by the carrier.
   *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
   *  - DELIVERY_IN_PROGRESS: DELIVERY_IN_PROGRESS indicates that the delivery is on its way.
   *  - ARRIVED_AT_PICKUP_POINT: ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready to be picked up by the client.
   *  - DELAYED: DELAYED indicates that the delivery will be delivered later than expected.
   *  - RETURNED: RETURNED indicates that the delivery has been returned.
   *  - INFO: INFO indicates some uncategorized event.
   *  - ERROR: ERROR indicates that some error occurred.
   *  - PICKUP_REGISTERED: PICKUP_REGISTERED indicates that the carrier has been informed about the delivery.
   *  - NOTIFICATION_SENT: NOTIFICATION_SENT indicates that a delivery notification has been sent to the customer.
   *  - BOOKING_RECEIVED_BY_CARRIER: BOOKING_RECEIVED_BY_CARRIER indicates that the carrier has received booking information for the parcel.
   *  - FAILED: FAILED indicates that there was an attempt to deliver the package but it failed.
   *  - FORWARDED_TO_THIRD_PARTY: FORWARDED_TO_THIRD_PARTY indicates that the package was handed over to another third party for continuation of delivery.
   *  - IN_CUSTOMS: IN_CUSTOMS indicates that the package is undergoing customs clearance.
   *  - REDIRECTED: REDIRECTED indicates that package has been redirected from its original path.
   *  - LOST: LOST indicates that package has been lost and delivery cannot proceed.
   *  - DAMAGED: DAMAGED indicates that package has been damaged.
   *  - RETURNED_TO_SENDER: RETURNED_TO_SENDER indicates that package will be returned to the sender.
   *  - PICKUP_DELAYED: PICKUP_DELAYED indicates that the package pickup from point of origin is delayed.
   *  - PICKED_UP: PICKED_UP indicates that the package was received from the point of origin.
   *  - UNDELIVERABLE: UNDELIVERABLE indicates that the package cannot be delivered.
   *  - CONTACT_MERCHANT_SUPPORT: CONTACT_MERCHANT_SUPPORT indicates that the consumer should contact merchant's customer support.
   *  - CONTACT_CARRIER_SUPPORT: CONTACT_CARRIER_SUPPORT indicates that the consumer should contact carrier's customer support.
   *  - INSTORE_ARRIVED_AT_PICKUP_POINT: `service-instore` specific statuses
   * INSTORE_ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
   *  - INSTORE_PARCEL_REFUSED: INSTORE_PARCEL_REFUSED indicates that the parcel has been refused by the customer.
   *  - INSTORE_PARCEL_PICKED_UP: INSTORE_PARCEL_PICKED_UP indicates that the parcel has been picked up by the customer.
   *  - INSTORE_PARCEL_OVERDUE: INSTORE_PARCEL_OVERDUE indicates that the parcel has not been picked up by the customer, and is overdue.
   *  - INSTORE_PARCEL_RETURNED: INSTORE_PARCEL_RETURNED indicates that the parcel has been returned by the customer.
   * It's indicates RETURN direction.
   *  - INSTORE_PARCEL_RELOCATED: INSTORE_PARCEL_RELOCATED indicates that the parcel has been relocated by store staff.
   *  - INVALID_BOOKING: INVALID_BOOKING indicates that a booking failed due to external reasons likely a carrier 400
   *  - CANCEL_FAILED: CANCEL_FAILED indicates that a shipment failed to cancel due to not allowed from carrier.
   */
  status?: Status;
  status_message?: string;
}

export interface FetchShippingLabelsResponse {
  labels_urls?: string[];
  /** List of shipment IDs whose label format is different than requested or failed to convert. */
  not_included_shipments_ids?: string[];
}

export interface FilterCountRange {
  /** @format int64 */
  max?: string;
  /** @format int64 */
  min?: string;
}

export interface Filtering {
  address_from_countries?: string[];
  address_to_countries?: string[];
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  created_at_range?: DateTimeRange;
  direction_types?: DirectionType[];
  /** Shipments with those statuses must be excluded from the response */
  exclude_statuses?: Status[];
  /**
   * Id will be matched against:
   * shipment_id, tos_id and external_id, external_refs, order_number, tracking_numbers and customer_name.
   */
  id?: string;
  line_items?: FilterCountRange;
  shipment_ids?: string[];
  /** Provides a date interval. Depending on a case, `start` and `end` parts are not guaranteed to be present. */
  shipping_date_range?: DateTimeRange;
  shipping_methods?: string[];
  statuses?: Status[];
  tos_ids?: string[];
  with_customs_data?: boolean;
}

export interface GeneralCustomsDeclaration {
  /** Contact info of a buyer. */
  buyer_contact?: GeneralCustomsDeclarationContactInfo;
  /** A unique identification numbers of a buyer, for instance, EORI, VOEC. */
  buyer_identification_numbers?: TaxIdentificationNumbers;
  /**
   * A unique VAT tax identification number of a buyer / importer.
   * Deprecated: use `buyer_identification_numbers` instead.
   */
  buyer_tax_id_number?: string;
  /** Contents explanation - short general description. */
  contents_explanation?: string;
  /** Content type of goods inside the parcel. For example - Sale, Gift etc. See ContentsType reference for details. */
  contents_type?: ContentsType;
  /** Purchase currency. */
  currency?: string;
  /** Statement that provides the legal explanation that customs uses to process your shipment. Needs to meet certain country's law restrictions. */
  declaration_statement?: string;
  /** Billing for import duties and taxes, controls who is billed */
  duties_payer?: Payer;
  /** Information about the importer of record, if other party than the sold_to is used. */
  importer_of_record?: GeneralCustomsDeclarationImporterOfRecord;
  /** International Commercial Terms. */
  incoterms?: InCoTerms;
  /** The date when the invoice was issued. */
  invoice_date?: string;
  /** A unique number that identifies the invoice. */
  invoice_number?: string;
  /** List of items packed inside the parcel. */
  items?: GeneralCustomsDeclarationItem[];
  /** Name of port of departure, shipment or destination as required under the applicable delivery term. */
  place_of_incoterms?: string;
  /** The address of a seller / exporter. */
  seller_address?: Address;
  /** Contact info of a seller / exporter */
  seller_contact?: GeneralCustomsDeclarationContactInfo;
  /** A unique identification numbers of a seller / exporter, for instance, EORI, VOEC. */
  seller_identification_numbers?: TaxIdentificationNumbers;
  /**
   * A unique VAT tax identification number of a seller / exporter.
   * Deprecated: use `seller_identification_numbers` instead.
   */
  seller_tax_id_number?: string;
  /** The address of a buyer. */
  sold_to?: Address;
  /** Additional Instructions provided in the customs. */
  special_instructions?: string;
  /**
   * Total gross weight of the parcel in grams (including packaging).
   * @format int64
   */
  total_gross_weight?: number;
}

export interface GeneralCustomsDeclarationContactInfo {
  email?: string;
  phone?: string;
}

export interface GeneralCustomsDeclarationImporterOfRecord {
  /** Optional account number associated with the importer for customs/brokerage context. */
  account_number?: string;
  /** Importer address, usually in the import country. */
  address?: Address;
  /** Contact used by customs/broker for queries. */
  contact?: GeneralCustomsDeclarationContactInfo;
  /** A unique identification numbers of a importer, for instance, EORI, VOEC. */
  identification_numbers?: TaxIdentificationNumbers;
}

export interface GeneralCustomsDeclarationItem {
  /** Allows for providing one or more lines of additional information as needed such as manufacturer address info. [optional] */
  additional_information?: string[];
  /** Item's brand. */
  brand?: string;
  /** Item's commodity category, for example, babies products. */
  category?: string;
  /** Country of origin - country were this item were produced. */
  country_of_origin?: string;
  /** Used to describe items such as composition. For example, 50 percent wool and 50 percent leather. [optional] */
  description?: string;
  /** Harmonized System tariff number. */
  hs_tariff_number?: string;
  /** Name of this item. */
  name?: string;
  /**
   * Quantity of this item.
   * @format int64
   */
  quantity?: number;
  /** Item references can be used to communicate order numbers, make, models, dangerous goods content identifiers, registration numbers and more. [optional] */
  references?: ItemReference[];
  /** SKU of this item. */
  sku?: string;
  /**
   * Used only for special case scenarios when unit_value should not be used
   * such as when custom declarations should be using a transfer price for eg. US exports
   * @format int64
   */
  unit_alternative_value?: number;
  /**
   * Gross weight of the item in grams (including packaging), without taking quantity into account.
   * @format int64
   */
  unit_gross_weight?: number;
  /**
   * Net weight of the item in grams, without taking quantity into account.
   * @format int64
   */
  unit_net_weight?: number;
  /**
   * Value of the single item, without taking quantity into account.
   * Only integer values are supported and because of that provided value should always be in smallest currency unit possible (fractional monetary unit).
   * For example, 25.99 USD should be converted to 2599.
   * @format int64
   */
  unit_value?: number;
}

/**
 * International Commercial Terms.
 *
 *  - EXW: Ex Works.
 *  - FCA: Free Carrier.
 *  - FAS: Free Alongside Ship.
 *  - FOB: Free On Board.
 *  - CFR: Cost And Freight.
 *  - CIF: Cost, Insurance and Freight.
 *  - CPT: Carriage Paid To.
 *  - CIP: Carriage Insurance Paid To.
 *  - DAT: Delivered At Terminal.
 *  - DAP: Delivered At Place.
 *  - DDP: Delivered Duty Paid.
 *  - DAF: Delivered At Frontier.
 *  - DDU: Delivery Duty Unpaid.
 *  - DEQ: Delivered Ex Quay.
 *  - DES: Delivered Ex Ship.
 *  - DPU: Delivered at Place Unloaded.
 * @default "INCOTERMS_UNKNOWN"
 */
export type InCoTerms =
  | "INCOTERMS_UNKNOWN"
  | "EXW"
  | "FCA"
  | "FAS"
  | "FOB"
  | "CFR"
  | "CIF"
  | "CPT"
  | "CIP"
  | "DAT"
  | "DAP"
  | "DDP"
  | "DAF"
  | "DDU"
  | "DEQ"
  | "DES"
  | "DPU";

export interface ItemReference {
  /** The code corresponds to the type. Following the example of using MID as type the MID code should be specified here as a value. */
  code?: string;
  /** The type of code needs to be specified. For example "MID" (Manufacturers Identification Code) can be specified as the type. */
  type?: string;
}

/**
 * Physical item of the parcel. A parcel can contain many line
 * items. The parameters on the line item are used by the shipping rules
 * framework to make better shipping decisions.
 */
export interface LineItem {
  /** Currency of the line item. [optional] */
  currency?: string;
  /** Description of the product [optional] */
  description?: string;
  /**
   * Dimensions of the line item. [optional]
   * Length, height and width in millimeters.
   */
  dimensions?: Dimensions;
  /** Harmonized System tariff number. */
  hs_tariff_number?: string;
  /** Product name or title [required] */
  name?: string;
  /**
   * Price of the line item. [optional]
   * @format uint64
   */
  price?: number;
  /**
   * Number of items. [required]
   * @format uint64
   */
  quantity?: number;
  /** Unique product identifier. [required] */
  sku?: string;
  /** List of tags or attributes that can be attached to this line item. */
  tags?: string[];
  /**
   * Weight of the line item in grams. For example `200` is 0,2 kg.
   * @format uint64
   */
  weight?: number;
}

export interface ListShipmentsRequest {
  /**
   * Do not report count bigger than this number (cap it at count_limit). When this is empty or zero,
   * server default is used. When this value is greater than the server default, server default is used.
   * @format int32
   */
  count_limit?: number;
  filtering?: Filtering;
  order_by_direction?: OrderDirection;
  pagination?: Pagination;
  tos_id?: string;
}

export interface ListShipmentsResponse {
  /** This flag indicates that count was capped. There might be more result than count indicates. */
  capped_count?: boolean;
  shipments?: Shipment[];
}

export interface ListShipmentsSummariesRequest {
  /**
   * Do not report count bigger than this number (cap it at count_limit). When this is empty or zero,
   * server default is used. When this value is greater than the server default, server default is used.
   * @format int32
   */
  count_limit?: number;
  filtering?: Filtering;
  order_by_direction?: OrderDirection;
  pagination?: Pagination;
  tos_id?: string;
}

export interface ListShipmentsSummariesResponse {
  shipments?: ShipmentSummary[];
}

/** @default "DESCENDING" */
export type OrderDirection = "DESCENDING" | "ASCENDING";

export interface Pagination {
  /** @format uint64 */
  limit?: number;
  /** @format uint64 */
  offset?: number;
}

/**
 * Parcel is the physical package. One parcel can have at least one delivery
 * at a time.
 */
export interface Parcel {
  /** Contents of the parcel. */
  contents?: Contents;
  /** Timestamp when parcel was created. */
  created_at?: string;
  /** Deliveries associated with the parcel. */
  deliveries?: Delivery[];
  /** Length, height and width [optional]. */
  dimensions?: Dimensions;
  /** Custom description (notes) of a parcel. */
  free_text?: string;
  /** Unique ID of the parcel (uuid). */
  id?: string;
  /** Custom information about parcel visible on a label. */
  label_free_text?: string;
  /** Use `contents` instead [deprecated] */
  line_items?: LineItem[];
  /**
   * Index number of the individual parcel in a shipment, i.e parcel 3 of 5. [deprecated]
   * @format int64
   */
  parcel_number?: number;
  /**
   * Not used [deprecated].
   * @format int64
   */
  parcel_total?: number;
  /** ID of the shipment that parcel belongs to (uuid). */
  shipment_id?: string;
  /** Timestamp when parcel was last updated. */
  updated_at?: string;
  /**
   * Total weight of the parcel in grams.
   * @format uint64
   */
  weight?: number;
}

export interface Payer {
  /** Optional carrier account used to settle this charge (if supported by the carrier). */
  account?: string;
  /** Required when type is THIRD_PARTY. */
  address?: Address;
  /**
   * Specifies who is billed for this specific charge (transport or duties) relative to shipment parties.
   * This does NOT describe the legal role in customs; it only indicates who pays this charge.
   */
  type?: PayerPayerType;
}

/**
 *  - PAYER_TYPE_UNSPECIFIED: Unspecified payer.
 *  - SENDER: Sender/shipper pays the charge.
 *  - RECIPIENT: Recipient/consignee pays the charge.
 *  - THIRD_PARTY: Third-party pays the charge.
 * @default "PAYER_TYPE_UNSPECIFIED"
 */
export type PayerPayerType = "PAYER_TYPE_UNSPECIFIED" | "SENDER" | "RECIPIENT" | "THIRD_PARTY";

/**
 * Indicates the kind of pickup location
 * - UNKNOWN_PICKUP_LOCATION_TYPE: Location type is not known for some reason
 *  - LOCKER: Locker location type. Example Instabox or a DHL locker
 *  - STORE: Can be a merchant's store or any other store that handles logistics
 *  - POSTOFFICE: Postal office
 *  - MANNED: A manned service point
 * @default "UNKNOWN_PICKUP_LOCATION_TYPE"
 */
export type PickupLocationType = "UNKNOWN_PICKUP_LOCATION_TYPE" | "LOCKER" | "STORE" | "POSTOFFICE" | "MANNED";

/**
 * Shipment is the top level object in SOM. A shipment can be composed of
 * multiple parcels and each parcel can contain many deliveries. Only one
 * delivery can be active at a time.
 */
export interface Shipment {
  /** Addons that should be used for the shipment. */
  addons?: Addon[];
  /**
   * Address where the shipment will be dispatched from. Most often the
   * address of the warehouse [required].
   */
  address_from?: Address;
  /** Address where deliveries of this shipment should be returned to. */
  address_return?: Address;
  /**
   * Destination address. For example address of the service point or the click
   * and collect store [required].
   */
  address_to?: Address;
  /** ID of the carrier contract to be used for booking. */
  carrier_contract_id?: string;
  /** If the shipment is part of a consolidated shipment, this field will contain the details. */
  consolidated_shipment_details?: ConsolidatedShipmentDetails;
  /** Contents of shipment. Can be of different types - goods, transport orders and external orders. */
  contents?: Contents;
  /** Timestamp when shipment was created. */
  created_at?: string;
  /** Contains the customer information such as name, email, phone and address [required]. */
  customer_info?: CustomerInfo;
  /** Holds information about customs for the shipment. */
  customs?: Customs;
  /** DirectionType informs about initial shipment direction. */
  direction_type?: DirectionType;
  /**
   * Can be used to store a unique identifier from the merchant. For example
   * external order ID or external shipment ID.
   */
  external_id?: string;
  /** ID of the shipment (uuid). */
  id?: string;
  /** Use contents instead [deprecated] */
  line_items?: LineItem[];
  /**
   * Generic key-value object that can be used to attach additional
   * information to the shipment.
   */
  meta?: Record<string, string>;
  /** If the shipment is an outbound shipment, this field will contain the shipment id of the return shipment if it exists. */
  outbound_shipment_id?: string;
  /** Parcels associated with this shipment. */
  parcels?: Parcel[];
  /** If the shipment is a return shipment, this field will contain the shipment id of the outbound shipment if it exists. */
  return_shipment_id?: string;
  /**
   * Total value of the shipment including tax in cents. Example 10000 is 100 SEK.
   * @format uint64
   */
  shipment_value?: number;
  /** The date that the shipment will most likely be dispatched from the warehouse [required]. */
  shipping_date?: string;
  /** Site ID to which the shipment belongs to [internal]. */
  site_id?: string;
  /** Status of the shipment. Equivalent to the old Delivery.delivery_status. [required] */
  status?: ShipmentStatus;
  /** ID of a corresponding order. */
  tos_id?: string;
  /** [optional]  Defines who is billed for freight/transport charges. */
  transport_payer?: Payer;
  /** Timestamp when shipment was last updated. */
  updated_at?: string;
}

export interface ShipmentCount {
  /** @format int64 */
  count?: number;
  group?: StatusGroup;
}

export interface ShipmentStatus {
  /** Used to attach a message to the current status. [optional] */
  message?: string;
  /** The type of the status. Used to determine the state of the shipment. [required] */
  type?: ShipmentStatusStatusType;
}

/**
 * - CREATED: CREATED is the initial state of the shipment.
 *  - BOOKED: BOOKED indicates that shipment has been booked, also known as having a label generated for it.
 *  - PICKUP_SCHEDULED: PICKUP_SCHEDULED indicates that shipment has been scheduled for pickup. The intricacies of the pickup is determined by the carrier and the site configuration.
 *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
 *  - INVALID_BOOKING: INVALID_BOOKING indicates that a booking failed due to a bad request to the carrier service.
 *  - CANCEL_FAILED: CANCEL_FAILED indicates that the shipment could not be canceled by the carrier
 * @default "UNKNOWN"
 */
export type ShipmentStatusStatusType =
  | "UNKNOWN"
  | "CREATED"
  | "BOOKED"
  | "PICKUP_SCHEDULED"
  | "CANCELED"
  | "INVALID_BOOKING"
  | "CANCEL_FAILED";

export interface ShipmentSummary {
  /**
   * Address where the shipment will be dispatched from. Most often the
   * address of the warehouse.
   */
  address_from?: Address;
  /**
   * Destination address. For example address of the service point or the click
   * and collect store.
   */
  address_to?: Address;
  /** Timestamp when shipment was created. */
  created_at?: string;
  /** Contains the customer information such as name, email, phone and address. */
  customer_info?: CustomerInfo;
  /** Informtion related to the shipment direction. */
  direction_type?: DirectionType;
  /** ID of the shipment (uuid). */
  id?: string;
  /** The date that the shipment will most likely be dispatched from the warehouse. */
  shipping_date?: string;
  /** Shipping method associated with the shipment. */
  shipping_method?: string;
  /** Status of the shipment. */
  status?: Status;
  /** A short description of the shipment status. Most often set for errors. */
  status_message?: string;
  /** All tracking numbers connected with the shipment. */
  tracking_numbers?: string[];
  /** The time when the shipment was last updated. RFC3339 format. */
  updated_at?: string;
}

/**
 *  - CREATED: CREATED is the initial state of the delivery.
 *  - BOOKED: BOOKED indicates that delivery has been booked, also known as having a label generated for it.
 *  - PICKUP_REQUESTED: PICKUP_REQUESTED indicates that the shipment service marked the delivery as ready to be picked up.
 *  - PICKUP_SCHEDULED: PICKUP_SCHEDULED indicates that booking service recognized the aformentioned request and will include delivery
 * in the next pickup operation.
 *  - PICKUP_BOOKED: PICKUP_BOOKED indicates that the pickup operation that included this delivery has finished successfully.
 *  - IN_TRANSIT: IN_TRANSIT indicates that the delivery is under transportation.
 *  - DELIVERED: DELIVERED indicates that the package has been delivered by the carrier.
 *  - CANCELED: CANCELED indicates that the delivery has been suspended and will not proceed.
 *  - DELIVERY_IN_PROGRESS: DELIVERY_IN_PROGRESS indicates that the delivery is on its way.
 *  - ARRIVED_AT_PICKUP_POINT: ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready to be picked up by the client.
 *  - DELAYED: DELAYED indicates that the delivery will be delivered later than expected.
 *  - RETURNED: RETURNED indicates that the delivery has been returned.
 *  - INFO: INFO indicates some uncategorized event.
 *  - ERROR: ERROR indicates that some error occurred.
 *  - PICKUP_REGISTERED: PICKUP_REGISTERED indicates that the carrier has been informed about the delivery.
 *  - NOTIFICATION_SENT: NOTIFICATION_SENT indicates that a delivery notification has been sent to the customer.
 *  - BOOKING_RECEIVED_BY_CARRIER: BOOKING_RECEIVED_BY_CARRIER indicates that the carrier has received booking information for the parcel.
 *  - FAILED: FAILED indicates that there was an attempt to deliver the package but it failed.
 *  - FORWARDED_TO_THIRD_PARTY: FORWARDED_TO_THIRD_PARTY indicates that the package was handed over to another third party for continuation of delivery.
 *  - IN_CUSTOMS: IN_CUSTOMS indicates that the package is undergoing customs clearance.
 *  - REDIRECTED: REDIRECTED indicates that package has been redirected from its original path.
 *  - LOST: LOST indicates that package has been lost and delivery cannot proceed.
 *  - DAMAGED: DAMAGED indicates that package has been damaged.
 *  - RETURNED_TO_SENDER: RETURNED_TO_SENDER indicates that package will be returned to the sender.
 *  - PICKUP_DELAYED: PICKUP_DELAYED indicates that the package pickup from point of origin is delayed.
 *  - PICKED_UP: PICKED_UP indicates that the package was received from the point of origin.
 *  - UNDELIVERABLE: UNDELIVERABLE indicates that the package cannot be delivered.
 *  - CONTACT_MERCHANT_SUPPORT: CONTACT_MERCHANT_SUPPORT indicates that the consumer should contact merchant's customer support.
 *  - CONTACT_CARRIER_SUPPORT: CONTACT_CARRIER_SUPPORT indicates that the consumer should contact carrier's customer support.
 *  - INSTORE_ARRIVED_AT_PICKUP_POINT: `service-instore` specific statuses
 * INSTORE_ARRIVED_AT_PICKUP_POINT indicates that the delivery is ready for pickup at a pickup location.
 *  - INSTORE_PARCEL_REFUSED: INSTORE_PARCEL_REFUSED indicates that the parcel has been refused by the customer.
 *  - INSTORE_PARCEL_PICKED_UP: INSTORE_PARCEL_PICKED_UP indicates that the parcel has been picked up by the customer.
 *  - INSTORE_PARCEL_OVERDUE: INSTORE_PARCEL_OVERDUE indicates that the parcel has not been picked up by the customer, and is overdue.
 *  - INSTORE_PARCEL_RETURNED: INSTORE_PARCEL_RETURNED indicates that the parcel has been returned by the customer.
 * It's indicates RETURN direction.
 *  - INSTORE_PARCEL_RELOCATED: INSTORE_PARCEL_RELOCATED indicates that the parcel has been relocated by store staff.
 *  - INVALID_BOOKING: INVALID_BOOKING indicates that a booking failed due to external reasons likely a carrier 400
 *  - CANCEL_FAILED: CANCEL_FAILED indicates that a shipment failed to cancel due to not allowed from carrier.
 * @default "UNKNOWN"
 */
export type Status =
  | "UNKNOWN"
  | "CREATED"
  | "BOOKED"
  | "PICKUP_REQUESTED"
  | "PICKUP_SCHEDULED"
  | "PICKUP_BOOKED"
  | "IN_TRANSIT"
  | "DELIVERED"
  | "CANCELED"
  | "DELIVERY_IN_PROGRESS"
  | "ARRIVED_AT_PICKUP_POINT"
  | "DELAYED"
  | "RETURNED"
  | "INFO"
  | "ERROR"
  | "PICKUP_REGISTERED"
  | "NOTIFICATION_SENT"
  | "BOOKING_RECEIVED_BY_CARRIER"
  | "FAILED"
  | "FORWARDED_TO_THIRD_PARTY"
  | "IN_CUSTOMS"
  | "REDIRECTED"
  | "LOST"
  | "DAMAGED"
  | "RETURNED_TO_SENDER"
  | "PICKUP_DELAYED"
  | "PICKED_UP"
  | "UNDELIVERABLE"
  | "CONTACT_MERCHANT_SUPPORT"
  | "CONTACT_CARRIER_SUPPORT"
  | "INSTORE_ARRIVED_AT_PICKUP_POINT"
  | "INSTORE_PARCEL_REFUSED"
  | "INSTORE_PARCEL_PICKED_UP"
  | "INSTORE_PARCEL_OVERDUE"
  | "INSTORE_PARCEL_RETURNED"
  | "INSTORE_PARCEL_RELOCATED"
  | "INVALID_BOOKING"
  | "CANCEL_FAILED";

/** @default "UNKNOWN_GROUP" */
export type StatusGroup =
  | "UNKNOWN_GROUP"
  | "ALL_GROUP"
  | "CREATED_GROUP"
  | "BOOKED_GROUP"
  | "PICKUP_GROUP"
  | "IN_TRANSIT_GROUP"
  | "ERROR_GROUP"
  | "OTHER_GROUP";

export interface TaxIdentificationNumbers {
  /** Refers to the Employer Identification Number (EIN) for tax identification. */
  ein?: string;
  /**
   * Stands for Economic Operator Registration and Identification (EORI) number.
   * The EORI number is used for customs purposes to identify economic operators involved in the import or
   * export of goods within the European Union.
   */
  eori?: string;
  /** Refers to Their Majesty's Revenue and Customs (HMRC) identification. */
  hmrc?: string;
  /** Indicates the Import One-Stop Shop (IOSS) number. */
  ioss?: string;
  /** Represents the Permanent Account Number (PAN) used in certain jurisdictions. */
  pan?: string;
  /** Personal Customs Clearance Code : P+12digit number (Ex : P123456789012). Needed for shipments to South Korea */
  pccc?: string;
  /** Postponed VAT Accounting */
  pva?: string;
  /** Stands for Social Security Number (SSN) used in specific regions. */
  ssn?: string;
  /** Signifies the Taxpayer Identification Number (TIN) used for tax purposes. */
  tin?: string;
  /** UK Internal Market Scheme Number (Example: GBUKIMS123456789012202409011000) */
  ukims?: string;
  /** Stands for Value Added Tax (VAT) identification number. */
  vat?: string;
  /** Represents the Value of Exported Commodities (VOEC) number. */
  voec?: string;
}

/** Not used [internal] */
export interface TransitTime {
  end?: string;
  start?: string;
}

/** Reference to goods defined by a transport order. */
export interface TransportOrderContentItem {
  /**
   * Additional reference which can be used freely by the client to tie together
   * a SOM shipment with an internal ID.
   */
  external_ref?: string;
  /** Transport order id. */
  tos_id?: string;
}

export interface Error {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/som_search" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Som_Search API
 * @version 1.0
 * @baseUrl /v1/som_search
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  shipmentMetadataGet = {
    /**
     * No description
     *
     * @name SomSearchFetchShipmentMetadata
     * @request GET:/shipment_metadata.get
     * @secure
     */
    somSearchFetchShipmentMetadata: (
      query?: {
        shipment_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FetchShipmentMetadataResponse, Error>({
        path: `/shipment_metadata.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentsCount = {
    /**
     * No description
     *
     * @name SomSearchCountShipments
     * @summary CountShipments lists the number of total orders grouped by status.
     * @request POST:/shipments.count
     * @secure
     */
    somSearchCountShipments: (body: CountShipmentsRequest, params: RequestParams = {}) =>
      this.request<CountShipmentsResponse, Error>({
        path: `/shipments.count`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsGet = {
    /**
     * No description
     *
     * @name SomSearchListShipments
     * @request POST:/shipments.get
     * @secure
     */
    somSearchListShipments: (body: ListShipmentsRequest, params: RequestParams = {}) =>
      this.request<ListShipmentsResponse, Error>({
        path: `/shipments.get`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shipmentsGetLabels = {
    /**
     * No description
     *
     * @name SomSearchFetchShippingLabels
     * @summary FetchShippingLabels lists all label URLs for specific shipment IDs.
     * @request GET:/shipments.get_labels
     * @secure
     */
    somSearchFetchShippingLabels: (
      query?: {
        /** List of shipments IDs deliveries labels of which must be returned. */
        shipment_ids?: string[];
        /** Merge all labels into one PDF document. Used only for PDF format. */
        merge_labels?: boolean;
        /** Try to convert labels. */
        convert_labels?: boolean;
        /**
         * Labels format. If not specified return labels URLs in original format.
         * If not specified, PDF will be used by default.
         * @default "UNDEFINED"
         */
        format?: "UNDEFINED" | "PDF" | "SVG" | "PNG" | "ZPL";
      },
      params: RequestParams = {},
    ) =>
      this.request<FetchShippingLabelsResponse, Error>({
        path: `/shipments.get_labels`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  shipmentsSummariesGet = {
    /**
     * No description
     *
     * @name SomSearchListShipmentsSummaries
     * @request POST:/shipments_summaries.get
     * @secure
     */
    somSearchListShipmentsSummaries: (body: ListShipmentsSummariesRequest, params: RequestParams = {}) =>
      this.request<ListShipmentsSummariesResponse, Error>({
        path: `/shipments_summaries.get`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  statusGet = {
    /**
     * No description
     *
     * @name SomSearchFetchDeliveryStatus
     * @request GET:/status.get
     * @secure
     */
    somSearchFetchDeliveryStatus: (
      query?: {
        tracking_number?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FetchDeliveryStatusResponse, Error>({
        path: `/status.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
